import { Box } from "@mui/material";
import { AICancerGeneticsPage, HeroImage, HeroContentBox } from "./components";
import { NavBar } from "../navbar";
import { ContactUsSection } from "../contact";

import { useEffect } from "react";

export default function Home() {
  useEffect(() => {
    document.title = "Why Us";
  }, []);

  return (
    <Box sx={{ margin: 0, padding: 0 }}>
      <NavBar />
      <HeroImage />
      <HeroContentBox />
      <AICancerGeneticsPage />
      <ContactUsSection />
    </Box>
  );
}
